// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","wrapper":"Footer_wrapper__RAsdB","right":"Footer_right__rtqAj","icon":"Footer_icon__ctCoM"};